export const DISPOSITIF_PUBLICITAIRE = {
  title: 'Créer un dispositif publicitaire',
  titleModification: 'Modifier dispositif publicitaire {code}',
  titleModificationWithoutCode: 'Modifier dispositif publicitaire',
  detail: 'Détail dispositif publicitaire {code}',
  detailWithoutCode: 'Détail du dispositif publicitaire',
  nextStep: 'Étape suivante',
  dispositif: 'Dispositif',
  matériel: 'Matériel',
  faces: 'Faces',
  caracteristiques: 'Caractéristiques',
  restrictionAffichage: 'Restrictions d’affichage',
  code: 'Code',
  nom: 'Nom',
  support: 'Support',
  rechercheAdresse: 'Rechercher l\'adresse',
  TypeDispositif: 'Type de dispositif',
  confrere: 'Confrère',
  appartenanceDispositif: 'Ce dispositif m’appartient-il ?',
  montageDemontage: 'Montage / Démontage',
  dateMontage: 'Date de montage',
  dateDemontage: 'Date de démontage',
  etat: 'Etat',
  adresse: 'Adresse',
  codeInsee: 'Code INSEE',
  agglomeration: 'Agglomération',
  couleurRal: 'Couleur RAL',
  fournisseurElectricite: 'Fournisseur d\'électricité',
  restrictionsAffichage: 'Restriction affichage',
  particularite: 'Particularité',
  planRecollement: 'Plan recollement',
  cableEdfProx: 'Câble EDF à proximité ',
  distanceEnMCablesEdf: 'Distance en m des câbles EDF',
  hauteurSousPanneau: 'Hauteur sous panneau',
  nacelleNecessaire: 'Nacelle nécessaire',
  grueNecessaire: 'Grue nécessaire',
  echelleNecessaire: 'Echelle nécessaire',
  autreEquipementNecessaire: 'Autre équipement nécessaire',
  obstacle: 'Obstacle',
  declarationPrealable: 'Déclaration préalable',
  longueur: 'Longueur',
  largeurToit: 'Largeur toit',
  eclairable: 'Eclairable',
  arretBus: 'Arrêt de bus',
  codeTimeo: 'Code timeo',
  avecCaissonPub: 'Avec caisson',
  tags: 'Tags',
  tagArchive: 'Tag archivé',
  tagInfo: 'Si le tag n\'existe pas il sera créé en validant l\'entrée.',
  dispositifAccessoires: {
    libelle: 'Liste des accessoires',
    champs: {
      accessoire: 'Accessoires',
      quantite: 'Quantité',
    },
    action: {
      add: 'Ajouter un accessoire',
    },
  },
  valeurAcquisition: 'Valeur d\'acquisition',
  proprietaire: 'Propriétaire',
  publicitaire: 'Publicitaire',
  archive: 'Archivé',
  steps: {
    etape1: 'Etape 1',
    etape2: 'Etape 2',
    etape3: 'Etape 3',
    dispositif: 'Dispositif',
    materiel: 'Matériel',
    faces: 'Faces',
  },
  pj: 'Pièces jointes',
  commentaire: 'Commentaire',
  success: 'Création du dispositif réalisée avec succès',
  modification: 'Modification du dispositif réalisée avec succès',
  button: {
    SaveWithoutSynchroAdress: 'Sauvegarder sans modifier l\'adresse sur le(s) produit(s)',
    SaveWithSynchroAdress: 'Sauvegarder en modifiant l\'adresse sur le(s) produit(s)',
  },
  popUpSave: {
    title: 'Comportement de la sauvegarde',
    date: 'Date de démontage',
    titleDemonte: 'Démonter les dispositifs séléctionnés',
    modifierEtatMontage: 'Modifier les informations relatives à l\'état de montage sur les matériels et/ou faces liées ?',
    modifierAdresse: 'Sauvegarder et modifier l\'adresse sur le(s) produit(s) ?',
    commentaire: 'Commentaire',
  },
  infoGeneral: 'Informations générales',
  infoTechnique: 'Informations techniques',
  infoMobilier: 'Mobilier urbain',
  titleInOnglet: {
    info: 'Informations',
    accessoire: 'Accessoire',
  },
  divers: {
    title: 'Divers',
    pdlElectricite: 'PDL électricité',
    iot: 'IOT',
  },
  archivageDesarchiver: {
    archivage: 'Etes-vous sûr de vouloir archiver ce dispositif ?',
    desarchivage: 'Etes-vous sûr de vouloir désarchiver ce dispositif ?',
  },
  messages: {
    success: {
      archivage: 'Dispositif archivé avec succès.',
      desarchivage: 'Dispositif désarchivé avec succès.',
      supprimer: 'Dispositif supprimé avec succès.',
    },
  },
  infoArchivageDesarchivage: {
    archivage: 'Cela va archiver aussi les matériels et faces liés à ce dispositif',
    desarchivage: 'Cela va désarchiver aussi les matériels et faces liés à ce dispositif',
  },
  voirBaux: 'Baux',
  titleAccesRapide: 'Accès rapide',
  tempsFort: 'Temps forts',
  secteur: 'Secteur(s)',
  popUpPreventionCopy: {
    message: 'Etes-vous sûr de vouloir dupliquer ce dispositif ?',
    success: 'Dispositif dupliqué avec succès.',
  },
  supprimer: {
    titre: 'Etes-vous sûr de vouloir supprimer ce dispositif ?',
    sousTitre: 'Cela va supprimer aussi les matériels liés à ce dispositif',
  },
  errors: {
    dispositifInNQuote: 'Dispositif {code} est utilisé dans {qte} devis',
    dispositifInNBill: 'Dispositif {code} est utilisé dans {qte} facture (s)',
    dispositifInNLogisticRequest: 'Dispositif {code} est utilisé dans {qte} demande d\'intervention(s)',
    dispositifInNOrder: 'Dispositif {code} est utilisé dans {qte} commande(s)',
    dispositifInNOtTech: 'Dispositif {code} est utilisé dans {qte} OT(s)',
    dispositifInNPrintRequest: 'Dispositif {code} est utilisé dans {qte} demande d\'impression(s)',
  },
};

export const LISTE_DISPOSITIF = {
  title: 'Liste des dispositifs',
  tab: {
    code: 'Code',
    nomCommercial: 'Nom du client',
    nom: 'Libellé du dispositif',
    type: 'Type',
    support: 'Support',
    etatMontage: 'Etat montage',
    adresse: 'Adresse',
    agence: 'Agence',
    archive: 'Archivé',
  },
  filtre: {
    code: 'Code(s)',
    type: 'Type(s)',
    support: 'Support(s)',
    avecCoordonnees: 'Avec coordonées',
    etat: 'Etat(s)',
    adresse: 'Adresse',
    ville: 'Ville(s)',
    agglomerations: 'Agglomération(s)',
    departements: 'Département(s)',
    dateMontage: 'Date de montage',
    dateDemontage: 'Date de démontage',
    agence: 'Agence',
    actif: 'Actif',
    codePostal: 'Code(s) postal',
    errors: {
      dateMontage: 'La date de début de montage est plus grande que la date de fin',
      dateDemontage: 'La date de début de démontage est plus grande que la date de fin',
    },
    client: 'Client(s)',
    tags: 'Tag(s)',
    arretsBus: 'Arrêt(s) bus',
    tempsFort: 'Temps forts',
    marques: 'Marque(s)',
    secteur: 'Secteur(s)',
    exclureVille: 'Exclure ville(s)',
    hasSecteur: 'Présent dans un secteur',
    nomenclature: 'Type(s) de nomenclature',
  },
  archivageDesarchiver: {
    archivage: 'Etes-vous sûr de vouloir archiver ce dispositif ?',
    desarchivage: 'Etes-vous sûr de vouloir désarchiver ce dispositif ?',
  },
  messages: {
    success: {
      archivage: 'Dispositif archivé avec succès.',
      desarchivage: 'Dispositif désarchivé avec succès.',
    },
    error: {
      dispositifEtatDiffDemonte: 'Le dispositif ne peut-être archivé que si son état de montage est à "démonté"',
      dispositifMateriel: 'Le dispositif ne peut-être archivé que si ses matériels sont à l\'état "démonté"',
      dispositifFace: 'Le dispositif ne peut-être archivé que si ses faces sont à l\'état "démonté"',
      desarchivageImpossible: 'Le dispositif ne peut-être désarchivé que si son emplacement est désarchivé',
      demonteImpossible: 'Un des dispositif ne peut pas être à l\'état souhaité',
    },
  },
  infoArchivageDesarchivage: {
    archivage: 'Cela va archiver aussi les matériels et faces liés à ce dispositif ?',
    desarchivage: 'Cela va désarchiver aussi les matériels et faces liés à ce dispositif ?',
  },
  actions: {
    ajouterSecteur: 'Ajouter dans un secteur',
    supprimerSecteur: 'Supprimer d\'un secteur',
    archivageDispositif: 'Archiver/Désarchiver',
    archiverDispositif: 'Archiver',
    desarchiverDispositif: 'Désarchiver',
    impression: 'Générer demande impression temps fort',
    demonter: 'Démonter',
  },
  exportTempsFort: 'Export temps fort',
};

export const DETAIL_DISPOSITIF = {
  infoGeneral: {
    title: {
      caracteristiques: 'Caractéristique',
      commentaire: 'Commentaire',
      pj: 'Pièces jointes',
    },
    code: 'Code :',
    nom: 'Nom :',
    support: 'Support :',
    typeDispositif: 'Type de dispositif :',
    confrere: 'Confrère :',
    appartenanceDispositif: 'Ce dispositif m’appartient-il ?',
    commentaire: 'Commentaire :',
    declarationPrealable: 'Déclaration préalable :',
    restrictionsAffichage: 'Restriction d\'affichage :',
    tempsFort: 'Temps forts',
    secteur: 'Secteur(s) :',
  },
  infoTech: {
    title: {
      info: 'Informations',
      montageDemontage: 'Montage / démontage',
      accessoire: 'Accessoires',
    },
    dateMontage: 'Date de montage :',
    dateDemontage: 'Date de démontage :',
    etat: 'Etat :',
    fournisseur: 'Fournisseur d\'électricité :',
    planRecollement: 'Plan recollement : ',
    particularite: 'Particularité :',
    cableEdfProx: 'Câble EDF à proximité :',
    distanceEnMCablesEdf: 'Distance en m des câbles EDF :',
    hauteurSousPanneau: 'Hauteur sous panneau :',
    nacelleNecessaire: 'Nacelle nécessaire :',
    grueNecessaire: 'Grue nécessaire :',
    echelleNecessaire: 'Echelle nécessaire :',
    autreEquipementNecessaire: 'Autre équipement nécessaire :',
    obstacle: 'Obstacle :',
    declarationPrealable: 'Déclaration préalable :',
    proprietaire: 'Tiers propriétaire :',
    accessoire: {
      libelle: 'Libellé',
      quantite: 'Quantité',
      fournisseur: 'Fournisseur',
    },
  },
  mobilierUrbain: {
    title: {
      info: 'Informations',
    },
    longueur: 'Longueur : ',
    largeurToit: 'Largeur toit :',
    eclairable: 'Eclairable: ',
    couleurRal: 'Couleur RAL :',
    arretBus: 'Arrêt de bus :',
    codeTimeo: 'Code timeo :',
    avecCaissonPub: 'Avec caisson:',
    valeurAcquisition: 'Valeur acquisition :',
    publicitaire: 'Publicitaire :',
  },
  libelleForLogo: 'Dispositif publicitaire {code}',
  divers: {
    title: 'Divers',
    iot: 'IOT :',
    pdlElectricite: 'PDL électricité :',
  },
  steps: {
    caracteristiques: 'Caractéristiques',
    montage: 'Montage / démontage',
    adresse: 'Adresse cadastrale',
    divers: 'Divers',
    commentaire: 'Commentaire',
    pj: 'Pièces jointes',
  },
  popupDeplacerMateriel: {
    title: 'Déplacement de matériel',
    deplacer: 'Déplacer',
    materiel: 'Matériel',
    code: 'Code matériel',
    adresse: 'Adresse',
    format: 'Format',
    type: 'Type',
    deplacerVers: 'A déplacer vers le dispositif',
    dispositifCode: 'Code dispositif',
    dispositifLibelle: 'Nom dispositif',
    placeholder: 'Rechercher un dispositif',
    dispositif: 'Dispositif de destination',
    success: 'Le matériel a été déplacé avec succès.',
    errors: {
      materielId: 'Le matériel à déplacer.',
      dispositifId: 'Le dispositif vers qui déplacer.',
      materielDifferentClient: 'Le matériel ne peut pas être déplacé car il appartient à un client différent.',
    },
    titlePopUpPrevenvention: 'Etes-vous sûr de vouloir déplacer ce matériel ?',
  },
};
